import * as React from 'react';
import master, { ShapeTypes } from '../../Master';
import { Validated } from '../Validated';

interface ShapeTile {
  readonly id: number;
  readonly name: string;
  readonly width: number;
  readonly height: number;
  readonly margin: number;
}

export interface SymbolSvgOption {
  readonly id: number;
  readonly name: string;
}

interface PlaceCodeShapeInputProps {
  tiles: ShapeTile[];
  symbolSvgs: SymbolSvgOption[];

  shapeSchemeId: number;
  /** 図形の種類の欄の下に赤字で出す誤り。作画文字列が、この図形の種類にない自動計測項目を使っているときに渡す */
  validationMessage?: string;
  shapeSymbolSchemeId: number | null;
  onChangeShape: (id: number) => void;
  onChangeShapeSymbol: (id: number | null) => void;
}

export const PlaceCodeShapeInput: React.FC<PlaceCodeShapeInputProps> = function (
  props
) {
  return (
    <div>
      <div className="App-input_container">
        <label className="App-label" htmlFor="PlaceCreateCodePage-shape">
          図形の種類
        </label>
        <Validated message={props.validationMessage}>
          <select
            id="PlaceCreateCodePage-shape"
            value={props.shapeSchemeId}
            onChange={(event) => {
              const shapeId = parseInt(event.target.value);
              props.onChangeShape(shapeId);

              // シンボルの初期値
              switch (shapeId) {
                case ShapeTypes.Symbol:
                  if (props.symbolSvgs.length > 0) {
                    props.onChangeShapeSymbol(props.symbolSvgs[0].id);
                  } else {
                    props.onChangeShapeSymbol(null);
                  }
                  break;
                default:
                  props.onChangeShapeSymbol(null);
                  break;
              }
            }}
          >
            {master.Shapes.map((shape) => (
              <option key={shape.id} value={shape.id}>
                {shape.name}
              </option>
            ))}
          </select>
        </Validated>
      </div>
      <div>
        {(function () {
          switch (props.shapeSchemeId) {
            case ShapeTypes.Symbol:
              return (
                <div className="App-input_container">
                  <label className="App-label" htmlFor="PlaceCreateCodePage-shape_symbol">
                    シンボルの種類
                  </label>
                  <select
                    id="PlaceCreateCodePage-shape_symbol"
                    value={props.shapeSymbolSchemeId ?? 0}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      props.onChangeShapeSymbol(val === 0 ? null : val);
                    }}
                  >
                    {props.symbolSvgs.map((shapeSymbol) => (
                      <option key={shapeSymbol.id} value={shapeSymbol.id}>{shapeSymbol.name}</option>
                    ))}
                  </select>
                </div>
              );
          }
        })()}
      </div>
    </div>
  );
};
